import React, { useState } from "react";
import { useTheme } from "./theme";

export default function Waitlist() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { theme } = useTheme();
  const palette = theme.palette;

  const rawBase = process.env.REACT_APP_API_BASE_URL ?? "";
  const trimmedBase = rawBase.endsWith("/") ? rawBase.slice(0, -1) : rawBase;
  const waitlistEndpoint =
    trimmedBase.length > 0
      ? `${trimmedBase}/api/waitlist/register`
      : "/api/waitlist/register";

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim() || loading) return;
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(waitlistEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error("Submission failed");
      setSubmitted(true);
      setEmail("");
    } catch (err: any) {
      setError(err?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="waitlist"
      style={{
        padding: "4rem 1rem",
        background: palette.background,
        color: palette.textPrimary,
        textAlign: "center",
      }}
    >
      <div
        style={{
          maxWidth: "600px",
          margin: "0 auto",
          background: palette.card,
          border: `1px solid ${palette.border}`,
          borderRadius: "16px",
          padding: "1rem",
          boxShadow: palette.shadow,
        }}
      >
        <h2
          style={{
            fontSize: "1.75rem",
            fontWeight: 800,
            marginBottom: "1rem",
            color: palette.textPrimary,
          }}
        >
          Join the Waitlist
        </h2>
        <p style={{ color: palette.textMuted, marginBottom: "1.5rem" }}>
          Be the first to know when we launch. No spam, just updates.
        </p>

        {submitted ? (
          <p style={{ color: palette.accent, fontWeight: 600 }}>
            Thanks! You're on the list.
          </p>
        ) : (
          <form
            onSubmit={handleSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.75rem",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              style={{
                width: "100%",
                maxWidth: "400px",
                padding: "0.8rem 1rem",
                borderRadius: "8px",
                border: `1px solid ${palette.inputBorder}`,
                background: palette.inputBackground,
                color: palette.textPrimary,
                fontSize: "1rem",
              }}
            />
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: "0.8rem 1.2rem",
                borderRadius: "8px",
                border: "none",
                fontWeight: 600,
                background: palette.accentGradient,
                color: palette.textOnAccent,
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              {loading ? "Submitting..." : "Register"}
            </button>
            {error && <small style={{ color: palette.danger }}>{error}</small>}
            <p
              style={{
                color: palette.textMuted,
                marginBottom: "1.5rem",
                fontWeight: 600,
              }}
            >
              + enjoy a FREE 7-day LaunchPad trial when we go live.
            </p>
          </form>
        )}
      </div>
    </section>
  );
}
